"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomLesson = exports.getCustomLessons = exports.verifyDeleteMock = void 0;
/* eslint-disable import/prefer-default-export */
exports.verifyDeleteMock = {
    linkedLessons: [
        {
            displayName: 'ciso test 4',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            uuid: 'c465930d-d68d-4f67-9f91-d1fcef190180',
        },
        {
            displayName: 'ciso test 5',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            uuid: '90937db0-777c-4d62-af0a-f9d99c03abab',
        },
    ],
    unlinkedLessons: [
        {
            displayName: 'wip',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            uuid: 'e3080e65-b6c5-4430-bfe4-b06512a11812',
        },
    ],
    usersProgress: {
        notStarted: 597,
        started: 0,
        completed: 0,
    },
};
exports.getCustomLessons = {
    data: [
        {
            uuid: '66fc9fed-2c97-43b4-a93f-f75c4f1f525a',
            displayName: 'CISO Test CISO Test CISO Test CISO Test CISO Test CISO Test CISO Test CISO Test CISO Test   ',
            description: 'lesson desc',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            duration: 8,
            trackScore: true,
            zipFileName: 'CISO Test.zip',
            updatedAt: '2024-02-20T09:50:31.000Z',
            isLinked: true,
            courses: [
                {
                    displayName: 'CISO test',
                    published: true,
                },
            ],
            deletionEnabled: false,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
            tags: [
                { uuid: 'uuid1', displayName: 'displayName1' },
                { uuid: 'uuid4', displayName: 'displayName4' },
            ],
        },
        {
            uuid: '7f1043d4-fab7-445b-ab47-c35e771f7a25',
            displayName: 'CISO test 2',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            duration: '',
            updatedAt: '2024-02-20T09:50:31.000Z',
            isLinked: true,
            courses: [
                {
                    displayName: 'CISO test 2',
                    published: true,
                },
            ],
            deletionEnabled: false,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            uuid: '5c17c1ee-aef0-4871-80ce-6b48b8cad4fa',
            displayName: 'nir lesson',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            duration: '',
            updatedAt: '2024-02-20T09:50:31.000Z',
            isLinked: true,
            courses: [
                {
                    displayName: 'ciso 3 test',
                    published: true,
                },
            ],
            deletionEnabled: false,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            uuid: 'c465930d-d68d-4f67-9f91-d1fcef190180',
            displayName: 'ciso test 4',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            duration: '',
            updatedAt: '2024-02-20T09:50:31.000Z',
            isLinked: true,
            courses: [
                {
                    displayName: 'ciso test 4',
                    published: true,
                },
            ],
            deletionEnabled: false,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            uuid: '90937db0-777c-4d62-af0a-f9d99c03abab',
            displayName: 'ciso test 5',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            duration: '',
            updatedAt: '2024-02-20T09:50:31.000Z',
            isLinked: true,
            courses: [
                {
                    displayName: 'ciso test 5111 jkjkjkj kjkjkjk jkjkjkjkjk kjkjkjkj nkjkj',
                    published: true,
                },
            ],
            deletionEnabled: false,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            uuid: 'e3080e65-b6c5-4430-bfe4-b06512a11812',
            displayName: 'wip',
            iconUrl: 'https://platform-ui-spa.devcodebashing.com/icons/customCourses/customCourse-10.svg',
            duration: '24',
            updatedAt: '2024-03-07T10:23:02.000Z',
            isLinked: false,
            courses: [],
            deletionEnabled: true,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
    ],
    total: 6,
};
exports.getCustomLesson = {
    data: {
        uuid: 'c465930d-d68d-4f67-9f91-d1fcef190180',
        displayName: 'ciso test 4',
        description: 'Lesson description blah blah blah Lesson description blah blah blah Lesson description blah blah blah Lesson description blah blah blah Lesson descripti',
        iconUrl: 'https://picsum.photos/200/300?random=1',
        updatedAt: '2024-02-20T09:50:31.000Z',
        zipFileName: 'content.zip',
        trackScore: false,
        duration: '5min',
        isLinked: true,
        deletionEnabled: false,
        creator: {
            uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
            fullName: 'arie testing testing test',
            email: 'test@test.com',
            profilePictureUrl: 'https://picsum.photos/200/300?random=1',
        },
        courses: [
            {
                displayName: 'ciso test 4',
                published: true,
            },
        ],
        tags: [
            { uuid: '1', displayName: 'Misconfigurations' },
            { uuid: '2', displayName: 'Secrets' },
            { uuid: '3', displayName: 'Injection' },
            { uuid: '54', displayName: 'tag2' },
            { uuid: '6', displayName: 'Secrets' },
            { uuid: '78', displayName: 'Vulnerable' },
            { uuid: '12', displayName: 'Kubernetes' },
            { uuid: '121', displayName: 'tag2' },
            { uuid: '22', displayName: 'Docker' },
            { uuid: '211', displayName: 'tag2' },
        ],
    },
};
